module.exports = __webpack_public_path__ + "img/第6章_2-1_開化寺.jpg";